export const DISPLAY_DATE_FORMAT = {
    parse: {
        dateInput: 'YYYY-MM-DD',
    },
    display: {
        dateInput: 'DD-MMM-YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};


export const DISPLAY_MONTH_FORMAT = {
    parse: {
        dateInput: 'YYYY-MM',
    },
    display: {
        dateInput: 'MMM, YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};


export const SERVER_DATE_FORMAT_WITHOUT_TIME = 'YYYY-MM-DD';
export const SERVER_DATE_FORMAT_WITH_TIME = 'YYYY-MM-DD HH:mm:ss';
export const SERVER_DATE_FORMAT_FIRST_DAY_WITH_TIME = 'YYYY-MM-DD 00:00:00';
export const SERVER_DATE_FORMAT_CURRENT_DAY_WITH_TIME = 'YYYY-MM-DD 23:59:59';
export const EXAM_START_TIME = 'YYYY-MM-DD HH:mm:00';
export const EXAM_END_TIME = 'YYYY-MM-DD HH:mm:00';
export const EXAM_START_TIME_FORMAT = 'MM/DD/YYYY, hh:mm A';
export const EXAM_END_TIME_FORMAT = 'MM/DD/YYYY, hh:mm A';
export const SERVER_ONLY_DATE_FORMAT_WITHOUT_TIME = 'DD';
export const SERVER_YEAR_FORMAT_WITH_MONTH = 'YYYY-MM';
